<template>
  <div>
    <b-modal
      ref="editCustomer"
      lazy
      hide-footer
      size="xl"
      content-class="topcard cust-modal"
    >
      <template #modal-title>
        Customer Details
      </template>
      <EditCustomer :customerId="customerId" @customer-saved="customerSaved" />
    </b-modal>

    <b-form-group
      class="mb-0"
      style="z-index: 100;"
      v-click-outside="closeSearch"
    >
      <label class="form-control-label">
        Search Customer
      </label>
      <b-input-group style="z-index: 100">
        <div class="input-group-prepend" style="z-index: 100">
          <span class="input-group-text"><i class="fas fa-search"></i></span>
        </div>

        <b-form-input
          placeholder="Search by name, email, phone or customer number"
          type="text"
          v-model="searchTerm"
          ref="searchInput"
          @focus="searchFocus"
          style="z-index: 100; width:400px"
          v-debounce:300ms="search"
          autocomplete="off"
        >
        </b-form-input>

        <div class="input-group-append">
          <button
            class="btn btn-primary"
            type="button"
            :disabled="!customerId"
            @click="editSelectedCustomer"
          >
            <i class="fas fa-pencil"></i>
          </button>
        </div>

        <div class="autocomplete-items" v-show="isSearch">
          <div class="autocomplete-body">
            <div class="yolo">
              <div
                class="text-muted small"
                v-show="state == 'ready' && searchTerm == ''"
              >
                Search by name, email, or customer number.
              </div>

              <div
                v-show="
                  state == 'results.loading' || state == 'results.complete'
                "
              >
                <div class="addSearchTerm text-center pt-4 pb-4">
                  <b-button class="primary btn-block" @click="newCustomer"
                    >Add Customer - {{ searchTerm }}</b-button
                  >
                </div>

                <div v-show="state == 'results.loading'" class="resultsLoading">
                  <loading-svg :width="40" :height="40"></loading-svg>
                </div>

                <div
                  v-show="
                    state == 'results.complete' && searchResults.length == 0
                  "
                >
                  <div class="light-alert mb-0">
                    <i class="fa-solid fa-people-simple"></i>No customers found.
                  </div>
                </div>

                <div v-if="state == 'results.complete'">
                  <div
                    v-for="(item, index) in searchResults"
                    v-bind:key="index"
                    class="searchResultRow"
                    @click="selectedSearchItem(item)"
                  >
                    <customer-search-item :item="item"></customer-search-item>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="pipState == 'results.complete'">
              <div
                v-for="(item, index) in pipResults"
                v-bind:key="index"
                class="searchResultRow"
                @click="selectedSearchItem(item)"
              >
                <customer-search-item :item="item"> </customer-search-item>
              </div>
            </div>
          </div>
        </div>
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>
import CustomerSearchItem from "./CustomerSearchItem.vue";
import EditCustomer from "@/views/Components/Customer/EditCustomer.vue";

export default {
  name: "customer-select-add",
  components: { "customer-search-item": CustomerSearchItem, EditCustomer },
  data() {
    return {
      customerId: null,
      searchTerm: "",
      isSearch: false,
      searchResults: [],
      pipResults: [],
      state: "ready",
      pipState: "ready",
    };
  },
  props: {
    routerName: {
      type: String,
      default: "CustomerIndex", // default|light
      description: "Where to navigate on selection",
    },
  },

  methods: {
    customerSaved(cust) {
      this.searchTerm =
        (cust.firstName != null ? cust.firstName : "") +
        " " +
        (cust.lastName == null ? "" : cust.lastName) +
        " (" +
        cust.id +
        ")";

      this.$refs.editCustomer.hide();

      this.$emit("input", cust.id);
      this.$emit("customerSelected", cust);
    },
    editSelectedCustomer() {
      this.$refs.editCustomer.show();
    },
    async newCustomer() {
      var self = this;

      let firstName = null;
      let lastName = null;

      if (this.searchTerm.indexOf(" ")) {
        firstName = this.searchTerm.split(" ")[0];
        lastName = this.searchTerm.split(" ")[1];
      }

      var r = await this.$client.post("/api/customer/addCustomer", {
        firstName: firstName,
        lastName: lastName,
      });

      this.closeSearch();

      this.$emit("input", r.data.value.id);

      if (r.data.isSuccess) {
        this.customerId = r.data.value.id;
        this.editSelectedCustomer();
        this.$emit("input", r.data.value.id);
      }
    },
    search() {
      var self = this;

      if (self.searchTerm == "") {
        self.state = "ready";
        self.searchResults = [];
        return;
      }

      self.isSearch = true;
      self.state = "results.loading";

      self.$client
        .get("/api/customer/searchCustomer?name=" + self.searchTerm, {
          noProgress: true,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            var r = response.data.value;

            self.searchResults = r;
            self.state = "results.complete";
            return;
          }
        });
    },

    closeSearch() {
      this.isSearch = false;
    },
    async selectedSearchItem(item) {
      var self = this;

      this.customerId = item.id;

      this.searchTerm =
        (item.firstName != null ? item.firstName : "") +
        " " +
        (item.lastName == null ? "" : item.lastName) +
        " (" +
        item.id +
        ")";

      this.$emit("input", item.id);
      this.$emit("customerSelected", item);

      self.closeSearch();
    },
    searchFocus() {
      var self = this;
      console.log("Search focus..");
      self.$refs.searchInput.select();
    },
  },
};
</script>

<style scope>
.inputSearch {
  background-color: gray;
}
.autocomplete-head {
  float: right;
}
.resultsLoading {
  padding: 5px 0;
}
.autocomplete-body {
  margin: 30px 15px 15px 15px;
}
.searchResultRow {
  padding: 10px 15px;
  margin-left: -15px;
  margin-right: -15px;
}

.yolo {
  min-height: 50px;
}

.pip {
  border-top: solid 1px #e0e0e0;
  padding-top: 10px;
  margin-top: 25px;
  margin-bottom: 10px;
}

.addSearchTerm {
  border-top: solid 1px #e0e0e0;
}
</style>
